import { shallowEqual, useSelector } from 'react-redux'

import type { AppState } from '@/types'

type UseModalExport = {
  planId: unknown
  projectId: string | null
  projectName: string
  isOwner: boolean
  isOwned: boolean
  authenticated: unknown
  variant: unknown
  tabId: string | null
}

const useModalExport = (): UseModalExport => {
  return useSelector<AppState, UseModalExport>(
    ({ auth, manager: { project, meta }, canvas }) => ({
      planId: auth.planId,
      projectId: meta.id,
      projectName: project.settings.title,
      isOwner: meta.ownerId === auth.id,
      isOwned: !!meta.ownerId,
      authenticated: auth.authenticated,
      variant: project.settings.tree,
      tabId: canvas.tabs.activeTab,
    }),
    shallowEqual
  )
}

export default useModalExport
